<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Expense Category Summary"
            />
        </div>

        <div class="mt-2 px-2">
            <ExpenseProjectSummaryTable
                :tableData="expenseProjectSummary"
            />
        </div>
        <GlobalLoader />
    </div>
</template>

<script setup>
import {onMounted} from 'vue';
import {useRoute} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import ExpenseProjectSummaryTable from '@/components/molecule/company/report/ExpenseProjectSummaryTable.vue'
import useReport from '@/services/modules/dashboard/report.js'

const {expenseProjectSummary, fetchExpenseProjectSummary} = useReport()
const route = useRoute()
onMounted(() => {
  fetchExpenseProjectSummary(getQuery())
})
function getQuery () {
  return '?company_id=' + route.params.companyId
}

</script>
